import React from 'react';
import { withTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { ReactComponent as LogoutIcon } from '@public/images/exit.svg';
import { ILogoutButtonViewProps } from './interfaces';
import { useStyles } from './styles';

const LogoutButtonView = ({
  logoutUser,
  sx = {},
  t: translate,
}: ILogoutButtonViewProps) => {
  const classes = useStyles();
  const rootSx = { ...classes.root, ...sx };

  return (
    <Tooltip title={translate('tooltips.logout')}>
      <IconButton onClick={logoutUser} sx={rootSx} disableRipple>
        <LogoutIcon />
      </IconButton>
    </Tooltip>
  );
};

export default withTranslation()(LogoutButtonView);
